import * as actionTypes from './actionTypes';

export const onSubmitApplicationSuccess = response => {
    return {
        type: actionTypes.SUBMIT_APPLICATION_SUCCESS,
        response,
    };
};

export const onSubmitApplicationFailed = error => {
    return {
        type: actionTypes.SUBMIT_APPLICATION_FAILED,
        error,
    };
};

export const submitApplicationStart = (applicationDetails, applicantDetails, licenseFiles, employmentFiles) => {
    return {
        type: actionTypes.SUBMIT_APPLICATION,
        applicationDetails,
        applicantDetails,
        licenseFiles,
        employmentFiles,
    };
};
